/**
 * SubscriptionManagement object represents subscription management-related API endpoints and their methods.
 */
const SubscriptionManagement = {
  /**
   * Endpoint for retrieving all subscription.
   * @memberof SubscriptionManagement
   * @type {object}
   * @property {string} url - The URL for retrieving all subscription.
   * @property {string} method - The HTTP method for retrieving all subscription (GET).
   */
  getSubscriptionList: {
    url: "/subscription",
    method: "GET",
  },

  /**
   * Endpoint for adding a subscription.
   * @memberof SubscriptionManagement
   * @type {object}
   * @property {string} url - The URL for adding an subscription.
   * @property {string} method - The HTTP method for adding an subscription (POST).
   */

  addSubscription: {
    url: "/subscription",
    method: "POST",
  },

  /**
   * Endpoint for retrieving a specific subscription by ID.
   * @memberof SubscriptionManagement
   * @function getSingleSubscription
   * @param {string} id - The ID of the subscription to retrieve.
   * @returns {object} The endpoint object containing URL and method.
   */
  getSingleSubscription: (id) => ({
    url: `/subscription/${id}`,
    method: "GET",
  }),

    /**
   * Endpoint for updating a specific Subscription by ID.
   * @memberof SubscriptionManagement
   * @function updateSubscription
   * @param {string} id - The ID of the Subscription to update.
   * @returns {object} The endpoint object containing URL and method.
   */
    updateSubscription: (id) => ({
      url: `/subscription/${id}`,
      method: "PUT",
    }),
    /**
   * Endpoint for updating a specific Subscription status by ID.
   * @memberof SubscriptionManagement
   * @function updateSubscription
   * @param {string} id - The ID of the Subscription to update status.
   * @returns {object} The endpoint object containing URL and method.
   */
    updateSubscriptionStatus: (id) => ({
      url: `/subscription/${id}`,
      method: "PATCH",
    }),
};

// Export the SubscriptionManagement object for use in other modules
export default SubscriptionManagement;
